export function prefersReducedMotion() {
  return typeof globalThis.matchMedia === "function"
    && globalThis.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function cssMs(name, fallback) {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  const value = Number.parseFloat(raw);
  return Number.isFinite(value) ? value : fallback;
}

export function tokens() {
  return {
    fast: cssMs("--k-dur-fast", 120),
    base: cssMs("--k-dur-base", 200),
    slow: cssMs("--k-dur-slow", 320),
    stagger: cssMs("--k-stagger", 40),
  };
}

export function countUp(from, to, onUpdate, duration = tokens().slow * 3) {
  if (prefersReducedMotion()) {
    onUpdate(to);
    return () => {};
  }

  let frame = null;
  const start = performance.now();

  const step = (now) => {
    const progress = Math.min(1, (now - start) / duration);
    const eased = 1 - (1 - progress) ** 3;
    onUpdate(from + (to - from) * eased);
    if (progress < 1) frame = requestAnimationFrame(step);
  };

  frame = requestAnimationFrame(step);
  return () => cancelAnimationFrame(frame);
}

export function enterStagger(elements, { delay = 0 } = {}) {
  if (prefersReducedMotion()) return [];

  const { slow, stagger } = tokens();

  return Array.from(elements).map((element, index) => element.animate(
    [
      { opacity: 0, transform: "translateY(24px)" },
      { opacity: 1, transform: "translateY(0)" },
    ],
    {
      duration: slow * 2,
      delay: delay + index * stagger * 2,
      easing: "cubic-bezier(0.22, 1, 0.36, 1)",
      fill: "backwards",
    },
  ));
}

export function parseNumeric(value) {
  const match = String(value).match(/^([^\d-]*)(-?\d[\d\s]*(?:[.,]\d+)?)(.*)$/);
  if (!match) return null;

  const raw = match[2].replace(/[\s]/g, "").replace(",", ".");
  const number = Number.parseFloat(raw);
  if (Number.isNaN(number)) return null;

  const decimals = (match[2].match(/[.,](\d+)$/) || [])[1];

  return {
    prefix: match[1],
    suffix: match[3],
    number,
    decimals: decimals ? decimals.length : 0,
  };
}

export function formatNumeric(parsed, number) {
  const formatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: parsed.decimals,
    maximumFractionDigits: parsed.decimals,
  }).format(number);

  return `${parsed.prefix}${formatted}${parsed.suffix}`;
}
